module.exports = __webpack_public_path__ + "img/meteor.ec6c3910.png";